export default "__VITE_ASSET__44eea55a__"